import React from 'react';

import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import CustomLoader from 'common/components/customLoader';

// Reads the loading flags itself, so a loading change only re-renders the loader and not the whole customer page
const PageLoader: React.FC = () => {
	const isLoading = useThreeSixtyNewStore((state) => state.isLoading || state.accountTables.isLoadingTable);

	return <CustomLoader advanced isLoading={isLoading} />;
};

export default PageLoader;
